import React, { useState } from 'react';


interface HeroContentProps {
  showButtons: boolean;
  openSlider: (section: string) => void;
  scrollToGallery?: () => void; // Made optional since it's unused
  openVideoModal: () => void;
}

function HeroContent({ showButtons, openSlider, openVideoModal }: HeroContentProps) {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);

  const openContactModal = () => {
    setIsContactModalOpen(true);
  };

  const closeContactModal = () => {
    setIsContactModalOpen(false);
  };

  return (
    <>
      <div className="relative z-10 px-4 flex flex-col items-center justify-center h-full py-12 max-w-4xl mx-auto">
        <div className="flex-1 flex items-center justify-center px-8 sm:px-4 w-full">
          {showButtons && (
            <div className="space-y-8 gap-4 w-full">
              <button
                onClick={openContactModal}
                className="w-full text-gray-200 hover:text-teal-200 py-3 px-6 sm:py-5 rounded-xl text-lg sm:text-2xl font-light hover:bg-teal-600/50 transition-transform hover:scale-105 animate-fade-in-up"
                style={{ animationDelay: '0.7s' }}
                aria-label="Открыть информацию о контактах"
              >
                Контакты
              </button>
            </div>
          )}
        </div>
        <div className="text-center mb-16">
          <h2
            className="text-4xl sm:text-5xl md:text-6xl font-medium text-white mb-4 animate-fadeInUp drop-shadow-lg"
            style={{ animationDelay: '2s' }}
          >
            Совтехэкспорт
          </h2>
          <p
            className="text-lg sm:text-xl md:text-2xl text-teal-100 mb-8 animate-fadeInUp drop-shadow-md"
            style={{ animationDelay: '4s' }}
          >
            Открытое акционерное общество
          </p>
        </div>
      </div>

      {/* Contact Modal */}
      {isContactModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
          <div className="bg-teal-900/95 p-6 rounded-xl max-w-md w-full mx-4 animate-fade-in-up">
            <h3 className="text-2xl font-medium text-white mb-4">Связаться с нами</h3>
            <p className="text-lg text-teal-100 mb-2">
              <strong>Адрес:</strong> Минск, Петра Мстиславца 1-121
            </p>
            <p className="text-lg text-teal-100 mb-6">
              <strong>Телефон:</strong>{' '}
              <a href="tel:+3752901350" className="hover:text-teal-200 underline">
                +375 290 13 50
              </a>
            </p>
            <button
              onClick={closeContactModal}
              className="w-full bg-teal-600 text-white py-2 px-4 rounded-xl hover:bg-teal-700 transition-colors"
              aria-label="Закрыть модальное окно"
            >
              Закрыть
            </button>
          </div>
        </div>
      )}
    </>
  );
}

export default HeroContent;